import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  min-height: 400px;
  align-items: stretch;
  align-content: stretch;

  & > div {
    width: 100%;
  }
`;
